/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of ImageExport condition.
 */
export enum ImageExportConditionType {
  ImageExportConditionTypeReady = 'Ready',
}
